import React, { useState } from 'react';
import {Tab, Tabs, Dropdown, Accordion, Card, Button} from 'react-bootstrap';
import Lottie from 'react-lottie';
import animationData from '../../assets/animation-data/tick.json';
import SendReceiptModal from './SendReceiptModal';
const defaultOptions = {
    loop: true,
    autoplay: true, 
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
const Invoice = (props) => {
    const [showSendReceiptModal, setShowSendReceiptModal] = useState(false);
    
    const goHome=()=>{
        let self=this
        let info={
            bookingDate:props.bookingState.bookingDate
        };
        props.history.push({pathname:'/diary/' + localStorage.getItem('salonId'),state:info})
    }

    const completeAndRebook=()=>{
        try {
            const bs = props.bookingState || {};
            const services = (bs.selectedService || []).map(s => {
                const svc = s.service || {};
                return {
                    serviceId: svc.serviceId || svc._id || s.serviceId || '',
                    serviceName: svc.serviceName || s.serviceName || '',
                    servicePrice: parseFloat(s.servicePrice || svc.servicePrice || 0),
                    serviceTime: parseInt(s.serviceTime || svc.serviceTime || 30),
                    processingTime: parseInt(s.processingTime || 0),
                };
            });
            const clientObj = bs.selectedClient || {};
            const clientName = typeof clientObj === 'string' ? clientObj : (clientObj.name || clientObj.first_name || '');
            const clientId = bs.selectedClientId || clientObj._id || '';
            const staffId = bs.hairdresserId || '';
            sessionStorage.setItem('beu-rebook', JSON.stringify({ staffId, services, client: clientId ? { _id: clientId, name: clientName } : null }));
        } catch (e) { /* ignore */ }
        props.history.push('/diary/' + localStorage.getItem('salonId'));
    }

    return(
        <>
            <div className="cm_right_panal client_checkout phone-payemnet-taken-change iinvoice">
                <div className="text-center">
                <Lottie options={defaultOptions}
                    height={100}
                    width={100}
                    />
               <h4 className="">Checkout Completed</h4>
                    <p>Full payment received.</p>
                </div>
                <div className="text-center complete__btn">
                    <div className="cm_btns mobile-change-btn" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        <button className="btn btn-blue btn-block" onClick={goHome}>Complete</button>
                        <button className="btn btn-blue btn-block" onClick={completeAndRebook}>Complete & Rebook</button>
                        <button
                            className="btn btn-block"
                            onClick={() => setShowSendReceiptModal(true)}
                            style={{
                                border: '1px solid #000',
                                color: '#000',
                                backgroundColor: 'transparent'
                            }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                        >
                            Send Receipt
                        </button>
                    </div>
                </div>
            </div>
            
            {showSendReceiptModal && (
                <SendReceiptModal
                    bookingId={props.bookingState.bookingId}
                    clientEmail={props.bookingState.selectedClientId !== "64f5c7789a069cda0188fea3" ? props.bookingState.selectedClient?.email : ""}
                    onClose={() => setShowSendReceiptModal(false)}
                />
            )}
        </>
    )
}

export default Invoice;
